import React from 'react';

interface NoSsrState {
    mounted: boolean;
}

interface NoSsrProps {
    fallback: React.ReactNode;
}

export default class NoSsr extends React.Component<NoSsrProps, NoSsrState> {
    state = {
        mounted: false,
    };
    componentDidMount() {
        this.setState(() => ({ mounted: true }));
    }
    render() {
        const { mounted } = this.state;
        return mounted ? this.props.children : this.props.fallback;
    }
}
